import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENDPOINTS } from '../../constants/endpoints.constants';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  file: Blob | null = null;
  private readonly http = inject(HttpClient);

  deleteMedia(id: string) {
    const url = `${ENDPOINTS.Application.Media.Remove}/${id}`;
    return this.http.delete(url);
  }
}
